export interface FsLprRawFleetReadCapture {
  id: string;
  dateTime: string;
  geoLocation: {
    lat: number;
    lon: number;
  };
}
